import { render, staticRenderFns } from "./sorting-question-solution-component.vue?vue&type=template&id=60bf03d8&scoped=true&"
import script from "./sorting-question-solution-component.vue?vue&type=script&lang=ts&"
export * from "./sorting-question-solution-component.vue?vue&type=script&lang=ts&"
import style0 from "./sorting-question-solution-component.vue?vue&type=style&index=0&id=60bf03d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf03d8",
  null
  
)

export default component.exports